var _a;
import { createContext } from 'react';
import { cbrConfig } from '../../../helpers';
export var defaultContext = {
    config: cbrConfig,
    accountId: (_a = sessionStorage.getItem('selectedAccountId')) !== null && _a !== void 0 ? _a : '',
    backToAccountManagerHandler: function () { return null; },
    triggerAnalyticsEvent: function () { return null; },
    handleProfileClick: function () { return null; },
    isLoading: false,
    setIsLoading: function () { return null; },
    setRemoveCBRSessionStorage: function () { return null; },
    removeCBRSessionStorage: true
};
var CBRContext = createContext(defaultContext);
export default CBRContext;
